:host {
    display: block;

    * {
        font-family: inherit !important;
    }

    .ti-portfolio-viewer-svgContainer {
        overflow: hidden;
    }

    svg {
        // svg displays tooltip for all shapes from its <title> tag by default.
        // Disable that and click, etc.
        pointer-events: none;
        // Need this, so the width can be set via page layout or style on the component
        width: 100%;
    }

    .ti-portfolio-viewer-link {
        cursor: pointer;
        // For blocks with links, allow tooltip.
        pointer-events: auto;

        // disable tooltip for text inside the blocks.
        text {
            pointer-events: none;
        }
    }

    .ti-portfolio-viewer-grey:hover {
        :not(text, tspan) {
            fill: #cccccc;
        }
        text {
            fill: black;
        }
    }

    .ti-portfolio-viewer-teal:hover {
        :not(text, tspan) {
            fill: #9ed6df;
        }
        text {
            fill: black;
        }
    }

    .ti-portfolio-viewer-red:hover {
        :not(text, tspan) {
            fill: #efb9b9;
        }

        text {
            fill: black;
        }
    }

    .ti-portfolio-viewer-orange:hover {
        :not(text, tspan) {
            fill: #ffd488;
        }

        text {
            fill: black;
        }
    }
}
